import { useEffect, useCallback, useRef, FunctionComponent } from 'react';
import type { Props } from './types';
import { Presentation} from './presentation';

const PAGINATE_PER = 20;

export const Component: FunctionComponent<Props> = (props) => {
  const articlesListInnerRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (articlesListInnerRef.current) {
      articlesListInnerRef.current.style.opacity = props.loading ? '0' : '1.0';
    }
  }, [props.loading]);

  const handlePaginateClick = useCallback(
    (page: number) => {
      props.handlePaginateClick(page);
    },
    [props.handlePaginateClick]
  );

  const page = props.page || 1;
  const paginatedRecruitmentIds = props.recruitment_ids.slice(
    (page - 1) * PAGINATE_PER,
    page * PAGINATE_PER
  );

  const presentationProps = {
    ...props,
    paginatedRecruitmentIds,
    handlePaginateClick,
    articlesListInnerRef,
  };

  return <Presentation {...presentationProps} />;
};
